import React, { Fragment, useState } from "react";
import WebcamCapture from "../WebcamCapture";
import FrontImg from '../../assets/images/front-document.png';

const FrontDocument = (props) => {
  const [frontImg, setFrontImg] = useState();

  return (
    <Fragment>
      <div className="w-full flex flex-col align-center justify-between flex-grow fade-in">
        <label
          className="block text-gray-700 text-base font-bold mb-2 mt-4 text-base md:text-lg lg:text-xl lg:mt-8 lg:mb-4"
          htmlFor="email"
        >
          Cargue la imagen de la parte frontal
        </label>
        <img src={FrontImg} className="object-contain w-1/2 h-1/2 lg:w-1/4 self-center" />
        <WebcamCapture content="Cargar imagen frontal" handleOnClickNext={props.handleOnClickNext} setFrontImg={setFrontImg} setFrontImageDoc={props.setFrontImageDoc} dispatch={props.dispatch} />
      </div>
      <div>
        {props.frontDocument ? (
          <input
            className="fna-color py-2 px-4 mt-5 mb-5 rounded focus:outline-none focus:shadow-outline"
            type="button"
            value="Siguiente"
            onClick={() => {
              props.handleOnClickNext();
            }}
          />
        ) : null}
      </div>
    </Fragment>
  );
};

export default FrontDocument;
